export default function() {
    this.validationToken();
}
